// extracted by mini-css-extract-plugin
module.exports = {"container":"experience-module--container--39tRB","imageContainer":"experience-module--imageContainer--S9jje","logo":"experience-module--logo--1vc06"};